import { createSlice } from '@reduxjs/toolkit';
import { BUTTON_TYPES } from '../../components/ShowContactByDataPoint/constants';
import { SEARCH_STATUS } from '../../utils/constants';
import { ALL_OPTIONS_FILTER } from '../../views/BulkEnrich/constants';
import appTypes from '../app/types';
const initialState = {
    contactIds: [],
    companies: [],
    filters: [ALL_OPTIONS_FILTER],
    searchStatus: SEARCH_STATUS.IDLE,
    requestId: '',
    uniqueSearchId: '',
    sessionId: '',
    maskedId: '',
    showCreditSplitPopup: false,
    creditSplitErrorType: '',
    selectedDataPointType: BUTTON_TYPES.EMAIL_AND_PHONE,
    creditSplitClickedButtonType: 'show',
};
const slice = createSlice({
    name: 'BULK',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setSearchResult(state, { payload }) {
            var _a, _b, _c, _d, _e, _f;
            state.contactIds = (_a = payload.contactIds) !== null && _a !== void 0 ? _a : [];
            state.companies = (_b = payload.companies) !== null && _b !== void 0 ? _b : [];
            state.requestId = (_c = payload.requestId) !== null && _c !== void 0 ? _c : '';
            state.uniqueSearchId = (_d = payload.uniqueSearchId) !== null && _d !== void 0 ? _d : '';
            state.sessionId = (_e = payload.sessionId) !== null && _e !== void 0 ? _e : '';
            state.maskedId = (_f = payload.maskedId) !== null && _f !== void 0 ? _f : '';
        },
        setInvalidateStatus(state, { payload }) {
            state.invalidated = payload;
        },
        setSearchStatus(state, { payload }) {
            state.searchStatus = payload;
        },
        setFilters(state, { payload }) {
            state.filters = payload.length ? payload : [ALL_OPTIONS_FILTER];
        },
        setShowCreditSplitPopup(state, { payload }) {
            state.showCreditSplitPopup = payload.isOpen;
            state.creditSplitErrorType = payload.isOpen ? payload.creditSplitErrorType || '' : '';
        },
        setSelectedDataPointType(state, { payload }) {
            state.selectedDataPointType = payload;
        },
        setCreditSplitClickedButtonType(state, { payload }) {
            state.creditSplitClickedButtonType = payload;
        },
        clearSearchResult(state) {
            return Object.assign(Object.assign({}, initialState), { filters: state.filters, 
                // startSearch clears the result; keep the flag so the sidebar keeps owning the load
                invalidated: state.invalidated, creditSplitClickedButtonType: state.creditSplitClickedButtonType });
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
